import styled from "styled-components";

interface Props {
  width?: number;
  active?: boolean | "hover";
  borderWidth?: number;
}

export const MatchingBriefIconSvg = (props: Props) => {
  return (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_10521_11401)">
        <path
          d="M44.0625 22.5C44.0625 10.5914 34.4086 0.9375 22.5 0.9375C10.5914 0.9375 0.9375 10.5914 0.9375 22.5C0.9375 34.4086 10.5914 44.0625 22.5 44.0625C34.4086 44.0625 44.0625 34.4086 44.0625 22.5Z"
          stroke="url(#paint0_linear_10521_11401)"
          stroke-width={props.borderWidth || 2}
        />
        <path
          d="M16.1523 31.9414C15.9505 31.7917 15.8268 31.5898 15.7812 31.3359C15.7422 31.082 15.7845 30.7793 15.9082 30.4277L17.9492 24.3535L12.7344 20.6035C12.4284 20.3887 12.2168 20.1673 12.0996 19.9395C11.9824 19.7116 11.9629 19.4772 12.041 19.2363C12.1191 19.002 12.2721 18.8262 12.5 18.709C12.7279 18.5918 13.0306 18.5365 13.4082 18.543L19.8047 18.582L21.748 12.4785C21.8652 12.1204 22.0117 11.8503 22.1875 11.668C22.3698 11.4857 22.5846 11.3945 22.832 11.3945C23.0859 11.3945 23.3008 11.4857 23.4766 11.668C23.6589 11.8503 23.8086 12.1204 23.9258 12.4785L25.8691 18.582L32.2656 18.543C32.6432 18.5365 32.946 18.5918 33.1738 18.709C33.4017 18.8262 33.5547 19.002 33.6328 19.2363C33.7109 19.4772 33.6914 19.7116 33.5742 19.9395C33.457 20.1673 33.2454 20.3887 32.9395 20.6035L27.7246 24.3535L29.7656 30.4277C29.8893 30.7793 29.9284 31.082 29.8828 31.3359C29.8438 31.5898 29.7233 31.7917 29.5215 31.9414C29.3197 32.0977 29.0918 32.1497 28.8379 32.0977C28.584 32.0521 28.3073 31.9219 28.0078 31.707L22.832 27.9082L17.666 31.707C17.3665 31.9219 17.0898 32.0521 16.8359 32.0977C16.582 32.1497 16.3542 32.0977 16.1523 31.9414ZM17.5586 30.0078C17.5716 30.0273 17.6009 30.0208 17.6465 29.9883L22.3438 26.4043C22.5 26.2806 22.6628 26.2188 22.832 26.2188C23.0078 26.2188 23.1738 26.2806 23.3301 26.4043L28.0273 29.9883C28.0729 30.0208 28.1022 30.0273 28.1152 30.0078C28.1217 29.9948 28.1217 29.9655 28.1152 29.9199L26.1719 24.334C26.1263 24.2103 26.1035 24.0931 26.1035 23.9824C26.11 23.8717 26.1426 23.7708 26.2012 23.6797C26.2598 23.582 26.3444 23.4941 26.4551 23.416L31.3184 20.0566C31.3639 20.0306 31.3802 20.0046 31.3672 19.9785C31.3607 19.959 31.3314 19.9492 31.2793 19.9492L25.3711 20.0566C25.1693 20.0632 25.0033 20.0241 24.873 19.9395C24.7428 19.8483 24.6484 19.7018 24.5898 19.5L22.8906 13.8457C22.8776 13.7936 22.8581 13.7676 22.832 13.7676C22.8125 13.7676 22.7962 13.7936 22.7832 13.8457L21.084 19.5C21.0254 19.7018 20.931 19.8483 20.8008 19.9395C20.6706 20.0241 20.5046 20.0632 20.3027 20.0566L14.3945 19.9492C14.3424 19.9492 14.3132 19.959 14.3066 19.9785C14.2936 20.0046 14.3099 20.0306 14.3555 20.0566L19.2188 23.416C19.3294 23.4941 19.4141 23.582 19.4727 23.6797C19.5312 23.7708 19.5605 23.8717 19.5605 23.9824C19.5671 24.0931 19.5475 24.2103 19.502 24.334L17.5586 29.9199C17.5456 29.9655 17.5456 29.9948 17.5586 30.0078Z"
          fill="#3D3C5A"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_10521_11401"
          x1="4.37308e-08"
          y1="22.5005"
          x2="44.9992"
          y2="22.5005"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.13" stop-color="#FA3CAB" />
          <stop offset="0.24" stop-color="#F94C94" />
          <stop offset="0.57" stop-color="#F87C54" />
          <stop offset="0.81" stop-color="#F79A2C" />
          <stop offset="0.94" stop-color="#F7A61D" />
        </linearGradient>
        <clipPath id="clip0_10521_11401">
          <rect width="45" height="45" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const MatchingBriefIcon = styled(MatchingBriefIconSvg)<{
  active?: boolean | "hover";
}>`
  & path:first-of-type {
    stroke: ${(p) => p.theme.color.typography.secondary}80;
  }

  & path:nth-of-type(2) {
    fill: ${(p) => p.theme.color.typography.secondary};
  }

  ${(p) =>
    p.active &&
    `
    path:first-of-type {
      stroke: url(#paint0_linear_10521_11401);
    }

    path:nth-of-type(2) {
      fill: ${p.theme.color.typography.text};
    }
  `}

  .active & path:first-of-type {
    stroke: url(#paint0_linear_10521_11401);
  }

  .active & path:nth-of-type(2) {
    fill: ${(p) => p.theme.color.typography.text};
  }
`;
